export default __webpack_public_path__ + "static/media/madame_detail1.3d2d3c74.jpg";